import { getHttpClient } from '../../../../shared/utils/http-client.ts';
import { Chapter } from '../models/chapter';
import { updateChapterEndpoint } from './const';

export const updateChapter = (chapter: Chapter) => {
    return getHttpClient().post({ url: updateChapterEndpoint, data: JSON.stringify(chapter) });
};
